// extracted by mini-css-extract-plugin
module.exports = {"card":"RecordCard_card__hXwAm","song":"RecordCard_song__3iuPB","singer":"RecordCard_singer__Wou4Y","composer":"RecordCard_composer__1Bn1P","infos":"RecordCard_infos__3gJpd"};